import { Component, OnDestroy, OnInit } from '@angular/core';
import { IPageHeader } from '@modeso/aumico-lib-core-fe';
import Debug from 'debug';
import { RouteLabels } from '../../../enums/routeLabels.enum';
const debug = Debug('aumico:OrganizationSettingsPage');

@Component({
    selector: 'app-financial-statement-edit',
    styleUrls: ['./no-access.page.scss'],
    template: `<app-aumico-layout>
        <ng-container header>
            <ham-page-header [title]="pageHeader.value" [hasBackButton]="false"></ham-page-header>
            <ham-page-tab-navigation [navigationItems]="activeNavigationTabs"></ham-page-tab-navigation>
        </ng-container>
        <ng-container content>
            <div class="no-access-title">
                {{ 'aumico_ui_no_access_title' | i18next }}
            </div>
            <div class="no-access-message">
                {{ 'aumico_ui_no_access_message' | i18next }}
            </div>
        </ng-container>
    </app-aumico-layout>`,
})
export class NoAccessPage implements OnInit, OnDestroy {
    //labels
    public activeNavigationTabs: {
        routerLink: string;
        tabLabelKey: string;
    }[] = [];

    pageHeader: IPageHeader = {
        isLocalizedKey: true,
        value: RouteLabels.ORGANIZATION_SETTINGS,
    };

    ngOnInit(): void {
        // first grab the org once so we can set the breadcrumb and FCP‐related tab
    }

    ngOnDestroy(): void {}
}
